import { z } from 'zod';

export const paaPreDraftSchema = z.object({
  nom: z
    .string({ required_error: 'Le nom est obligatoire' })
    .min(1, 'Le nom ne doit pas être vide')
    .max(250, 'ce champ ne doit pas dépasser 250 caractères.'),
  acId: z.number({ required_error: "L'autorité contractante est obligatoire" }),
  annee: z
    .string({ required_error: "L'année est obligatoire" })
    .min(4, "L'année doit contenir 4 chiffres")
    .max(4, "L'année doit contenir 4 chiffres"),
});
